import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../AppContext/AuthContext";
import CorporateFacilityContext from "../AppContext/CorporateFacilityContext";
import CorporateDashboardLoading, { AppLoadingOverlay } from "../AppComponents/CorporateDashboard";

const PICKER_PATH = "/corporate-communities";

/**
 * Redirects corporate users without an active facility to the communities picker.
 */
const CorporateFacilityGate = ({ children }) => {
  const { IsAuthenticated, IsAuthChecking, IsSpeak2User } = useContext(AuthContext);
  const corporateCtx = useContext(CorporateFacilityContext);
  const location = useLocation();

  if (IsAuthChecking || !IsAuthenticated) {
    return children;
  }

  if (!corporateCtx) {
    return children;
  }

  const { requiresFacilitySelection, profileReady, loading, isCorporateUser } = corporateCtx;

  if (IsSpeak2User && !profileReady) {
    return <AppLoadingOverlay />;
  }

  if (
    IsSpeak2User
    && loading
    && isCorporateUser
    && location.pathname !== PICKER_PATH
  ) {
    return (
      <CorporateDashboardLoading message="Loading your corporate dashboard…" />
    );
  }

  if (requiresFacilitySelection && location.pathname !== PICKER_PATH) {
    return <Navigate to={PICKER_PATH} replace />;
  }

  return children;
};

export default CorporateFacilityGate;
